module.exports = __webpack_public_path__ + "img/box-packaging-0@2x-min.9cc5bd9c.png";